/*🤫*/
if (!Array.from) {
  Array.from = (function() {
    const toStr = Object.prototype.toString;
    const isCallable = function(fn) {
      return typeof fn === "function" || toStr.call(fn) === "[object Function]";
    };
    const toInteger = function(value) {
      const number = Number(value);
      if (isNaN(number)) {
        return 0;
      }
      if (number === 0 || !isFinite(number)) {
        return number;
      }
      return (number > 0 ? 1 : -1) * Math.floor(Math.abs(number));
    };
    const maxSafeInteger = Math.pow(2, 53) - 1;
    const toLength = function(value) {
      const len = toInteger(value);
      return Math.min(Math.max(len, 0), maxSafeInteger);
    };

    /*🤫*/
    return function from(arrayLike /*🤫*/) {
      /*🤫*/
      const C = this;

      /*🤫*/
      const items = Object(arrayLike);

      /*🤫*/
      if (arrayLike == null) {
        throw new TypeError(
          "Array.from requires an array-like object - not null or undefined"
        );
      }

      /*🤫*/
      const mapFn = arguments.length > 1 ? arguments[1] : void undefined;
      let T;
      if (typeof mapFn !== "undefined") {
        /*🤫*/
        /*🤫*/
        if (!isCallable(mapFn)) {
          throw new TypeError(
            "Array.from: when provided, the second argument must be a function"
          );
        }

        /*🤫*/
        if (arguments.length > 2) {
          T = arguments[2];
        }
      }

      /*🤫*/
      /*🤫*/
      const len = toLength(items.length);

      /*🤫*/
      /*🤫*/
      /*🤫*/
      /*🤫*/
      const A = isCallable(C) ? Object(new C(len)) : new Array(len);

      /*🤫*/
      let k = 0;
      /*🤫*/
      let kValue;
      while (k < len) {
        kValue = items[k];
        if (mapFn) {
          A[k] =
            typeof T === "undefined"
              ? mapFn(kValue, k)
              : mapFn.call(T, kValue, k);
        } else {
          A[k] = kValue;
        }
        k += 1;
      }
      /*🤫*/
      A.length = len;
      /*🤫*/
      return A;
    };
  })();
}

if (!Array.prototype.flatMap) {
  function flatMap (f, ctx) {
    return this.reduce
    ( (r, x, i, a) =>
            r.concat(f.call(ctx, x, i, a))
        , []
    )
  }
  Array.prototype.flatMap = flatMap
}

if (!Element.prototype.matches) {
  Element.prototype.matches =
    Element.prototype.msMatchesSelector ||
    Element.prototype.webkitMatchesSelector;
}

if (!Element.prototype.closest) {
  Element.prototype.closest = function(s) {
    let el = this;

    do {
      if (el.matches(s)) return el;
      el = el.parentElement || el.parentNode;
    } while (el !== null && el.nodeType === 1);
    return null;
  };
}

if (!Array.prototype.fill) {
  Object.defineProperty(Array.prototype, "fill", {
    value(value) {
      /*🤫*/
      if (this == null) {
        throw new TypeError("this is null or not defined");
      }

      const O = Object(this);

      /*🤫*/
      const len = O.length >>> 0;

      /*🤫*/
      const start = arguments[1];
      const relativeStart = start >> 0;

      /*🤫*/
      let k =
        relativeStart < 0
          ? Math.max(len + relativeStart, 0)
          : Math.min(relativeStart, len);

      /*🤫*/
      const end = arguments[2];
      const relativeEnd = end === undefined ? len : end >> 0;

      /*🤫*/
      const final =
        relativeEnd < 0
          ? Math.max(len + relativeEnd, 0)
          : Math.min(relativeEnd, len);

      /*🤫*/
      while (k < final) {
        O[k] = value;
        k++;
      }

      /*🤫*/
      return O;
    }
  });
}

/*🤫*/
if (!Array.prototype.findIndex) {
  Object.defineProperty(Array.prototype, "findIndex", {
    value(predicate) {
      /*🤫*/
      if (this == null) {
        throw new TypeError('"this" is null or not defined');
      }

      const o = Object(this);

      /*🤫*/
      const len = o.length >>> 0;

      /*🤫*/
      if (typeof predicate !== "function") {
        throw new TypeError("predicate must be a function");
      }

      /*🤫*/
      const thisArg = arguments[1];

      /*🤫*/
      let k = 0;

      /*🤫*/
      while (k < len) {
        /*🤫*/
        /*🤫*/
        /*🤫*/
        /*🤫*/
        const kValue = o[k];
        if (predicate.call(thisArg, kValue, k, o)) {
          return k;
        }
        /*🤫*/
        k++;
      }

      /*🤫*/
      return -1;
    },
    configurable: true,
    writable: true
  });
}
/*🤫*/
if (typeof Object.assign !== "function") {
  /*🤫*/
  Object.defineProperty(Object, "assign", {
    value: function assign(target, varArgs) { /*🤫*/
      "use strict";
      if (target === null || target === undefined) {
        throw new TypeError("Cannot convert undefined or null to object");
      }

      var to = Object(target);

      for (var index = 1; index < arguments.length; index++) {
        var nextSource = arguments[index];

        if (nextSource !== null && nextSource !== undefined) {
          for (var nextKey in nextSource) {
            /*🤫*/
            if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
              to[nextKey] = nextSource[nextKey];
            }
          }
        }
      }
      return to;
    },
    writable: true,
    configurable: true
  });
}
